@use '../../styles/box-sizing';


.m-appointment-request {
  display: flex;
  flex-direction: column;
  gap: var(--der-ui-spacing-L);
  container-type: inline-size;
  container-name: appointment-request;
  width: 100%;
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
}

.m-appointment-request__form {
  display: flex;
  flex-direction: column;
  gap: var(--der-ui-spacing-S);
  width: 100%;
  flex-wrap: wrap;

  .m-appointment-request__inputs-wrapper {
    display: flex;
    flex-direction: column;
    gap: var(--der-ui-spacing-S);
    width: 100%;
  }

  .m-appointment-request__input-wrapper {
    display: flex;
    flex-direction: row;
    gap: var(--der-ui-spacing-S);
    flex-wrap: wrap;

    &>* {
      width: 100%;
    }
  }
}

//Honeypot field
.m-appointment-request__email-confirmation {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 0;
  width: 0;
  z-index: -1;
}

.m-appointment-request__multiple-inputs-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--der-ui-spacing-S);
  flex-wrap: wrap;

  &>* {
    flex: 1;
    flex-basis: 100%;
  }
}

.m-appointment-request__data-protection-wrapper-wrapper {
    font-size: var(--der-ui-font-size-general-form-label);
    font-family: var(--der-ui-font-face-general-form-label);
    font-style: var(--der-ui-font-style-general-form-label);
    font-weight: var(--der-ui-font-weight-general-form-label);
    line-height: var(--der-ui-line-height-general-form-label);
    text-transform: var(--der-ui-text-transform-general-form-label);

  a:focus-visible {
    outline: 2px solid var(--der-ui-color-border-general-focus-outer);
    outline-offset: 2px;
  }
}

.m-appointment-request__checkbox-wrapper {
  display: flex;
  flex-direction: row;
  gap: var(--der-ui-spacing-S);
  align-items: flex-start;
  align-self: stretch;

  .m-appointment-request__checkbox-wrapper__text {
    font-size: var(--der-ui-font-size-general-form-label);
    font-family: var(--der-ui-font-face-general-form-label);
    font-style: var(--der-ui-font-style-general-form-label);
    font-weight: var(--der-ui-font-weight-general-form-label);
    line-height: var(--der-ui-line-height-general-form-label);
    text-transform: var(--der-ui-text-transform-general-form-label);
    margin-top: var(--der-ui-spacing-4XS);
  }
}

.m-appointment-request__appointment-booking-item {
  align-items: center;
  gap: var(--der-ui-spacing-L);
}

@container (min-width: 600px) {
      .m-appointment-request-form {
        display: flex;
        flex-direction: column;
        gap: var(--der-ui-spacing-S);
        flex-wrap: wrap;
      }

      .m-appointment-request__input-wrapper {
        width: 100%;
      }

      .m-appointment-request__multiple-inputs-wrapper {
        display: flex;
        flex-direction: row;
        gap: var(--der-ui-spacing-S);
        flex-wrap: wrap;

        &>* {
          width: 100%;
          flex-basis: 0;
        }
      }


}
